<!-- InputField.vue -->
<template>
  <DbSelect
    required
    v-model="selected"
    :value="selected"
    @change="handleInput"
    :disabled="disabled"
    class="w-full hydrated"
    name="height"
  >
    <option select></option>
    <option :selected="86 === selected" value="86">8'6</option>
    <option :selected="96 === selected" value="96">9'6</option>
  </DbSelect>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits } from "vue";
import DbSelect from "../DB-Components/DbSelect.vue";

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
let selected = ref<number>(props.modelValue);
const emit = defineEmits(["update:modelValue"]);

const handleInput = (event: HTMLInputElement) => {
  let target = event.target as HTMLInputElement;
  const numericValue = parseFloat(target.value.replace(/[^\d]/g, ""));
  const firstTwoDigits = parseFloat(numericValue.toString().substring(0, 2));
  target.value = firstTwoDigits.toString();
  emit("update:modelValue", firstTwoDigits);
};
</script>
